import PlayerEvent from '../../../core/events/player.event';
import * as AdEvent from '../../../core/events/ad.events';
import { logDebugging, logError } from '../../../log/logger';

export default class DisplayPlayerListeners {
  constructor(idComponent, duration, divSlot) {
    this.idComponent = idComponent;
    this.divSlot = divSlot;
    // this.playerHTML = playerHTML;
    this.isActivateListeners = false;
    this.isFirstStart = false;
    this.displayPlayerEvent = new PlayerEvent('onDisplayPlayerEvent');
    this.isEnded = false;

    this.duration = duration || 10;
    this.currentTime = 0;
  }

  remove() {
    clearInterval(this.interval);
    this.dispatchEvent([AdEvent.AdStopped, this.currentTime, this.duration]);
  }

  start() {
    this.currentTime = 0;
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.currentTime += 1;
        logDebugging(`this.duration ${this.duration}`);
        if (this.currentTime > this.duration) {
          clearInterval(this.interval);
          this.divSlot.style.display = 'none';
          this.divSlot.innerHTML = '';
          this.completeSent = true;
          this.dispatchEvent([AdEvent.AdStopped, this.currentTime, this.duration]);
        } else {
          this.dispatchEvent([AdEvent.AdRemainingTimeChange, this.currentTime, this.duration]);
        }
      }, 1000);
      this.state = 'playing';
      this.divSlot.style.display = 'block';
      this.dispatchEvent([AdEvent.AdStarted, this.currentTime, this.duration]);
    } else {
      this.errorSent = true;
      logError('[DisplayPlayerListeners] ya está iniciado el display');
    }
  }

  pause() {
    this.state = 'pause';
    clearInterval(this.interval);
    this.dispatchEvent([AdEvent.AdPaused, this.currentTime, this.duration]);
  }

  load() {
    this.state = 'load';
    clearInterval(this.interval);
    this.dispatchEvent([AdEvent.AdLoaded, this.currentTime, this.duration]);
  }

  resume() {
    if (this.state === 'pause') {
      this.start();
      this.dispatchEvent([AdEvent.AdPlaying, this.currentTime, this.duration]);
    }
  }

  dispatchEvent(arg) {
    this.displayPlayerEvent.fire(this, { message: arg });
  }
}
